import { render, staticRenderFns } from "./CrmOperatingSettings.vue?vue&type=template&id=0d2f1af9&scoped=true"
import script from "./CrmOperatingSettings.vue?vue&type=script&lang=js"
export * from "./CrmOperatingSettings.vue?vue&type=script&lang=js"
import style0 from "./CrmOperatingSettings.vue?vue&type=style&index=0&id=0d2f1af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f1af9",
  null
  
)

export default component.exports